import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';
import App from './App.jsx';
import './index.css';

// Initialize Google Analytics
const host = window.location.hostname;
if (host !== 'localhost' && host !== '127.0.0.1' && host !== '') {
  ReactGA.initialize('UA-58299741-1');
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
